import { createApp } from 'vue';

import Root from '@/components/Root.vue';

export const app = createApp(Root);
